<jhi-bary-card [titleKey]="'register.form.companyInformation.userForcerActivited'">
  <form autocomplete="off" body>
    <div class="row">
      <div class="col-12 col-md-6">
        <span>Statut du compte : {{ userForcedActivationForm.controls.userForcedActivation.value ? 'Validé' : 'En attente de validation' }}</span>
      </div>
      <div class="col-12 col-md-6">
        <jhi-bary-button
          *ngIf="!userForcedActivationForm.controls.userForcedActivation.value"
          data-id-cypress="force-activation"
          class="btn bary-btn mr-3 col-12 col-md-6"
          color="danger"
          [size]="'sm'"
          [label]="'baryApp.customer.confirm.userForcedActivedLabelButton' | translate"
          (click)="userForcedActived()"
        >
        </jhi-bary-button>
      </div>
    </div>
  </form>
</jhi-bary-card>
